import React, { useState, useEffect } from 'react';
import Terms from './terms';
import Policy from './policy';
import PolicyFr from './policy-fr';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import DownloadButton from './downloadButton';

const AboutContent = () => (
  <>
    <h2>A propos de DdoubleCam</h2>
    <p>
      DdoubleCam est une application mobile innovante qui vous permet de capturer des photos en utilisant simultanément les caméras avant et arrière de votre smartphone.<br />
      Cette fonctionnalité unique vous offre une nouvelle perspective sur la création de contenu, vous permettant de partager des moments de manière plus immersive et engageante.
    </p>
    <h3>Screenshots</h3>
    <div className="screenshots">
      <img src="/DdoubleCam/OnWay.png" alt="DdoubleCam Screenshot 1" className="ddoublecam-screenshot" />
      <img src="/DdoubleCam/Later.png" alt="DdoubleCam Screenshot 2" className="ddoublecam-screenshot" />
      <img src="/DdoubleCam/OpenGalery.png" alt="DdoubleCam Screenshot 3" className="ddoublecam-screenshot" />
      <img src="/DdoubleCam/Galery.png" alt="DdoubleCam Screenshot 4" className="ddoublecam-screenshot" />
      <img src="/DdoubleCam/Edit1.png" alt="DdoubleCam Screenshot 5" className="ddoublecam-screenshot" />
      <img src="/DdoubleCam/Edit2.png" alt="DdoubleCam Screenshot 6" className="ddoublecam-screenshot" />
    </div>
  </>
);

function DdoubleCam() {
  const [activeView, setActiveView] = useState('about');

  useEffect(() => {
    // On component mount, check the URL hash and set the active view accordingly.
    const hash = window.location.hash.substring(1);
    if (['about', 'terms', 'policy', 'policy-fr'].includes(hash)) {
      setActiveView(hash);
    }
  }, []); // Empty dependency array ensures this runs only once on mount.


  const handleLinkClick = (e, view) => {
    e.preventDefault();
    setActiveView(view);
    // Update the URL hash to allow for direct linking, without reloading the page.
    window.history.pushState(null, '', `#${view}`);
  };

  return (
    <div className="ddoublecam-container">
      <div className="ddoublecam-left-column">
        <h3>DdoubleCam : </h3>
        <div className="download-buttons">
          <DownloadButton platform="Android" link="https://play.google.com/store/apps/details?id=com.pastrycias.doublecam" Icon={FaGooglePlay} />
          <DownloadButton platform="iOS" link="https://apps.apple.com/us/app/ddoublecam/id6749810574" Icon={FaApple} />
          <DownloadButton platform="Instagram" link="https://www.instagram.com/ddoubleca" image="/logos/instagram.svg" />
          <DownloadButton platform="TikTok" link="https://www.tiktok.com/@ddoublecam" image="/logos/tiktok.svg" />
          <DownloadButton platform="Youtube" link="https://www.youtube.com/@DdoubleCam/shorts" image="/logos/youtube.svg" />
        </div>
        <div className="legal-links">
          <a href="#about" className={activeView === 'about' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'about')}>A propos</a>
          <a href="#terms" className={activeView === 'terms' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'terms')}>Terms of Service</a>
          <a href="#policy" className={activeView === 'policy' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'policy')}>Privacy Policy</a>
          <a href="#policy-fr" className={activeView === 'policy-fr' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'policy-fr')}>Politique de confidentialité</a>
        </div>
      </div>
      <div className="ddoublecam-right-column">
        {activeView === 'about' && <AboutContent />}
        {activeView === 'terms' && <Terms />}
        {activeView === 'policy' && <Policy />}
        {activeView === 'policy-fr' && <PolicyFr />}
      </div>
    </div>
  );
}

export default DdoubleCam;
